import { QUESTION_PLACE } from "../../../constants/question";
import type {
	QuestionBibleVerse,
	QuestionFromPlaceData,
	QuestionPlace,
} from "../../../types/question.types";

/** What the question window was opened with, carried across the Google round trip. */
export interface AskQuestionOpening {
	place: QuestionPlace;
	bibleVerses?: QuestionBibleVerse[];
	courseInfoForQuestion?: QuestionFromPlaceData;
	courseAuthors?: Array<{ _id?: string }>;
}

const hasKeys = (value?: object) => !!value && Object.keys(value).length > 0;

export const toResumePayload = ({
	place,
	bibleVerses,
	courseInfoForQuestion,
	courseAuthors,
}: AskQuestionOpening): string =>
	JSON.stringify({
		place,
		...(bibleVerses?.length ? { bibleVerses } : {}),
		...(hasKeys(courseInfoForQuestion) ? { courseInfoForQuestion } : {}),
		...(courseAuthors?.length ? { courseAuthors } : {}),
	});

export const fromResumePayload = (payload: string | undefined): AskQuestionOpening => {
	try {
		const opening = JSON.parse(payload ?? "");
		if (typeof opening?.place === "string") return opening;
	} catch {
		// A damaged marker still reopens the question, just without what it was opened with.
	}
	return { place: QUESTION_PLACE.HOME };
};
